import type { ReactNode } from 'react';
import { classNames } from '../classNames';

/** Cancels the card's padding on a phone, so a bordered child spans the card. */
export const SECTION_CARD_BLEED =
  'max-sm:-mx-5 max-sm:rounded-none max-sm:border-x-0';

/** Cancels the `PageShell` gutter on a phone, so the card spans the screen. */
export const PAGE_BLEED =
  'max-sm:-mx-6 max-sm:rounded-none max-sm:border-x-0 max-sm:shadow-none';

export function SectionCard({
  title,
  aside,
  className,
  children,
}: {
  title?: string;
  aside?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  return (
    <section
      className={classNames(
        'flex flex-col gap-4 rounded-xl border border-hairline bg-surface p-5 shadow-card',
        className,
      )}
    >
      {title ? (
        <div className="flex items-center justify-between gap-2 px-1">
          <h2 className="text-ink text-lg font-medium">{title}</h2>
          {aside}
        </div>
      ) : null}
      {children}
    </section>
  );
}
